/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuctionManagementListAuctionMetaResponse } from './AuctionManagementListAuctionMetaResponse';

export type AuctionManagementListAuctionMetaResponseApiRespoonse = {
    data?: AuctionManagementListAuctionMetaResponse;
    status?: AuctionManagementListAuctionMetaResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuctionManagementListAuctionMetaResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

